export default {
    data: state => state.data,
    type: state => state.type,
    active: state => state.active,
}